// College conferences with their Xfactor and Rank values
const collegeConferences = {
  SEC: { xfactor: 123.3, rank: 86.5 },
  B10: { xfactor: 119.5, rank: 82.8 },
  B12: { xfactor: 118.4, rank: 81.6 },
  BE: { xfactor: 113.4, rank: 75.3 },
  ACC: { xfactor: 110.7, rank: 70.7 },
  MWC: { xfactor: 107.0, rank: 64.4 },
  WCC: { xfactor: 105.6, rank: 61.8 },
  A10: { xfactor: 103.1, rank: 57.0 },
  CUSA: { xfactor: 102.2, rank: 54.9 },
  Amer: { xfactor: 101.3, rank: 53.0 },
  MVC: { xfactor: 101.3, rank: 53.0 },
  BW: { xfactor: 99.1, rank: 48.3 },
  Ivy: { xfactor: 97.5, rank: 44.8 },
  SC: { xfactor: 96.9, rank: 43.4 },
  WAC: { xfactor: 96.8, rank: 43.2 },
  Slnd: { xfactor: 96.2, rank: 42.0 },
  Sum: { xfactor: 96.1, rank: 41.8 },
  BSth: { xfactor: 96.0, rank: 41.4 },
  SB: { xfactor: 96.0, rank: 41.4 },
  Horz: { xfactor: 95.8, rank: 41.1 },
  CAA: { xfactor: 95.6, rank: 40.6 },
  MAC: { xfactor: 94.5, rank: 38.1 },
  BSky: { xfactor: 94.3, rank: 37.6 },
  ASun: { xfactor: 93.5, rank: 35.8 },
  MAAC: { xfactor: 91.2, rank: 31.1 },
  AE: { xfactor: 90.9, rank: 30.6 },
  PL: { xfactor: 90.8, rank: 30.5 },
  OVC: { xfactor: 90.2, rank: 29.1 },
  MEAC: { xfactor: 88.4, rank: 25.8 },
  NEC: { xfactor: 87.1, rank: 23.0 },
  SWAC: { xfactor: 85.9, rank: 21.2 },
};

export const classXfactorMap = {
  2025: {
    fr: 91.7,
    so: 97.9,
    jr: 100.6,
    sr: 105.7,
  },
  2024: {
    sr: 105.9,
    jr: 101.5,
    so: 97.4,
    fr: 90.3,
  },
};
// Lookup table for getting rank percentage from xfactor
const xfactorToRankMap = {
  194: 100.0,
  188: 100.0,
  178: 99.9,
  174: 99.9,
  173: 99.8,
  172: 99.8,
  170: 99.7,
  169: 99.7,
  167: 99.7,
  166: 99.6,
  165: 99.5,
  164: 99.4,
  163: 99.3,
  162: 99.3,
  161: 99.2,
  159: 99.1,
  158: 98.9,
  157: 98.9,
  156: 98.8,
  155: 98.7,
  154: 98.6,
  153: 98.5,
  152: 98.4,
  151: 98.2,
  150: 98.1,
  149: 97.8,
  148: 97.5,
  147: 97.1,
  146: 97.0,
  145: 96.9,
  144: 96.4,
  143: 96.2,
  142: 95.9,
  141: 95.7,
  140: 95.5,
  139: 95.1,
  138: 94.7,
  137: 94.3,
  136: 93.9,
  135: 93.6,
  134: 93.1,
  133: 92.5,
  132: 91.9,
  131: 91.5,
  130: 91.0,
  129: 90.5,
  128: 89.9,
  127: 89.2,
  126: 88.5,
  125: 87.7,
  124: 86.8,
  123: 85.9,
  122: 84.8,
  121: 84.2,
  120: 82.9,
  119: 81.8,
  118: 80.4,
  117: 79.4,
  116: 77.9,
  115: 76.7,
  114: 75.4,
  113: 74.0,
  112: 72.3,
  111: 70.7,
  110: 68.5,
  109: 67.1,
  108: 65.3,
  107: 63.8,
  106: 61.8,
  105: 59.6,
  104: 57.8,
  103: 55.9,
  102: 53.5,
  101: 51.3,
  100: 49.3,
  99: 47.1,
  98: 45.0,
  97: 42.8,
  96: 40.8,
  95: 38.0,
  94: 35.8,
  93: 33.7,
  92: 31.4,
  91: 29.9,
  90: 28.0,
  89: 25.9,
  88: 24.5,
  87: 22.5,
  86: 20.7,
  85: 19.0,
  84: 17.2,
  83: 15.5,
  82: 14.2,
  81: 13.0,
  80: 11.9,
  79: 11.2,
  78: 10.0,
  77: 9.2,
  76: 8.4,
  75: 7.7,
  74: 7.0,
  73: 6.5,
  72: 5.9,
  71: 5.5,
  70: 5.0,
  69: 4.6,
  68: 4.2,
  67: 3.9,
  66: 3.6,
  65: 3.4,
  64: 3.1,
  63: 2.9,
  62: 2.7,
  61: 2.5,
  60: 2.4,
  59: 2.2,
  58: 1.9,
  57: 1.8,
  56: 1.7,
  55: 1.6,
  54: 1.5,
  53: 1.4,
  52: 1.3,
  51: 1.2,
  50: 1.1,
  49: 1.0,
  48: 0.9,
  47: 0.9,
  46: 0.8,
  45: 0.7,
  44: 0.7,
  43: 0.7,
  42: 0.6,
  41: 0.5,
  40: 0.5,
  39: 0.5,
  38: 0.5,
  37: 0.4,
  36: 0.4,
  35: 0.4,
  34: 0.3,
  33: 0.3,
  32: 0.3,
  31: 0.3,
  30: 0.3,
  29: 0.3,
  28: 0.3,
  27: 0.2,
  26: 0.2,
  25: 0.2,
  24: 0.2,
  23: 0.2,
  22: 0.2,
  21: 0.2,
  20: 0.2,
  19: 0.2,
  18: 0.2,
  17: 0.2,
  16: 0.2,
  15: 0.1,
  14: 0.1,
  13: 0.1,
  12: 0.1,
  11: 0.1,
  10: 0.1,
  9: 0.1,
  8: 0.1,
  7: 0.1,
  6: 0.1,
  5: 0.1,
  4: 0.1,
  3: 0.1,
  2: 0.1,
  1: 0.1,
  0: 0.1,
  [-1]: 0.1,
  [-2]: 0.1,
  [-3]: 0.1,
  [-4]: 0.1,
  [-5]: 0.1,
  [-6]: 0.1,
  [-7]: 0.1,
  [-8]: 0.1,
  [-9]: 0.1,
  [-10]: 0.1,
  [-11]: 0.1,
  [-12]: 0.1,
  [-13]: 0.1,
  [-14]: 0.1,
  [-15]: 0.1,
  [-16]: 0.0,
};

/**
 * Get the rank percentage based on an xfactor score
 * @param {number} xfactor - The xfactor value to look up
 * @returns {number} - The rank percentage (0-100)
 */
export const getRankFromXfactor = (xfactor) => {
  // Round the xfactor to the nearest integer
  const roundedXfactor = Math.round(xfactor);

  // If the exact xfactor is in our map, return it
  if (xfactorToRankMap.hasOwnProperty(roundedXfactor)) {
    return xfactorToRankMap[roundedXfactor];
  }

  // If the xfactor is higher than our highest value, return 100%
  if (roundedXfactor > 194) {
    return 100.0;
  }

  // If the xfactor is lower than our lowest value, return 0%
  if (roundedXfactor < -16) {
    return 0.0;
  }

  // Find the closest values and interpolate between them
  const keys = Object.keys(xfactorToRankMap)
    .map(Number)
    .sort((a, b) => a - b);

  // Find the closest lower and higher values
  let lower = keys[0];
  let higher = keys[keys.length - 1];

  for (let i = 0; i < keys.length; i++) {
    if (keys[i] <= roundedXfactor) {
      lower = keys[i];
    }
    if (keys[i] >= roundedXfactor && higher > keys[i]) {
      higher = keys[i];
    }
  }

  // If we found an exact match through the loop
  if (lower === roundedXfactor) {
    return xfactorToRankMap[lower];
  }

  // Linear interpolation between the two closest values
  const lowerRank = xfactorToRankMap[lower];
  const higherRank = xfactorToRankMap[higher];
  const ratio = (roundedXfactor - lower) / (higher - lower);

  return lowerRank + ratio * (higherRank - lowerRank);
};

export default collegeConferences;
